import { defineComponent as _defineComponent } from 'vue'
import AuthButton from './ExternalAuthButton.vue';
import { computed, onMounted, ref, watch } from 'vue';
import { IExternalAuthHandler, useExternalAuth } from 'JS/composables/external-auth';
import { useServices } from '../../composables/services';
import { useViewportWidth } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalAuthLogin',
  props: {
    skipCartMerge: { type: Boolean },
    isCreateAccount: { type: Boolean },
    isVerifyAccount: { type: Boolean }
  },
  emits: ["error", "loading", "go-to-rewards", "signed-in"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'error', message: string): void
	(e: 'loading', loading: boolean): void
	(e: 'go-to-rewards'): void
	(e: 'signed-in', isRewardsMember: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	skipCartMerge: boolean,
	isCreateAccount?: boolean,
	isVerifyAccount?: boolean
}

const googleSignin = ref(null);
const { accountService } = useServices();





const viewportWidth = useViewportWidth();

const googleButtonOptions = computed((): google.accounts.id.GsiButtonConfiguration => {
	const padding = viewportWidth.value > 768 ?  20 : 30;
	const width = Math.min(Math.max(viewportWidth.value, 200) - padding, 400);
	return {
		type: 'standard',
		theme: 'outline',
		size: 'large',
		shape: 'rectangular',
		width,
		logo_alignment: 'left',
		text: props.isCreateAccount ? 'continue_with' : 'signin_with'
	};
});

const handleAuthenticate = (handler: IExternalAuthHandler) => 
	props.isVerifyAccount ? handler.verify() : handler.login();

const {
	apple,
	facebook,
	googleInit,
	error,
	result,
	loading
} = useExternalAuth(
	accountService,
	props.skipCartMerge ?? false,
	{
		parent: googleSignin,
		options: googleButtonOptions.value
	}
);

watch(error, () => {
	if (error.value) {
		emit('error', error.value);
	}
});

watch(loading, (oldVal, newVal) => {
	if (oldVal != newVal) {
		emit('loading', loading.value);
	}
});

watch(result, () => {
	if (result.value.success) {
		loading.value = true;
		if (result.value.isNewAccount) {
			if (result.value.headerJson && window.vueEventBus) {
				window.vueEventBus.$emit('header-vm', result.value.headerJson);
			}
			emit('go-to-rewards');
			return;
		}
		emit('signed-in', result.value.isRewardsMember);
	}
});

watch(googleButtonOptions, options => {
	googleInit({
		parent: googleSignin,
		options
	}, props.isVerifyAccount);
});

onMounted(() => {
	googleInit({
		parent: googleSignin,
		options: googleButtonOptions.value,
	}, props.isVerifyAccount);
});


return { __sfc: true,googleSignin, accountService, props, emit, viewportWidth, googleButtonOptions, handleAuthenticate, apple, facebook, googleInit, error, result, loading, AuthButton }
}

})